export default __webpack_public_path__ + "static/media/MiembrosIes.7140f824.png";